import { render, staticRenderFns } from "./ListProductsView.vue?vue&type=template&id=7c82e0c8"
import script from "./ListProductsView.vue?vue&type=script&lang=js"
export * from "./ListProductsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports